import type React from 'react';

import styles from './styles';
import Box from '@material-ui/core/Box';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import {
  CarIcon,
  CircleDivider,
  ContentLoader,
  DescriptionTitle,
  DriversCbIcon,
  FaceRecognitionIcon,
  HintPopup,
  VehicleGroupIcon,
} from '@cobliteam/base-components';

import useMediaStore from '../../../../store/zustand/useMediaStore';
import MediaFavoriteButton from '../../../MediaFavoriteButton/MediaFavoriteButton';

export interface MediaDialogDriverInfoProps {
  isFetchingMediaRows?: boolean;
}

const MediaDialogDriverInfo: React.FC<MediaDialogDriverInfoProps> = ({
  isFetchingMediaRows,
}) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);

  const { data: mediaView } = useGetMediaView(mediaViewId);

  const mediaData = mediaView?.mediaInfo;

  if (!mediaData || isFetchingMediaRows) {
    return (
      <div className={styles.driverInfo}>
        <div className={styles.alignIcons}>
          <DriversCbIcon />
          <ContentLoader key={0} width={100} height={19}>
            <rect x='0' y='0' width='100' height='19' />
          </ContentLoader>
        </div>
        <CircleDivider className={styles.spanContent} />
        <div className={styles.alignIcons}>
          <CarIcon />
          <ContentLoader key={0} width={60} height={19}>
            <rect x='0' y='0' width='60' height='19' />
          </ContentLoader>
        </div>
        <CircleDivider className={styles.spanContent} />
        <div className={styles.alignIcons}>
          <VehicleGroupIcon />
          <ContentLoader key={0} width={75} height={19}>
            <rect x='0' y='0' width='75' height='19' />
          </ContentLoader>
        </div>
      </div>
    );
  }

  const {
    driverName = 'Sem Motorista Associado',
    licensePlate = 'Sem placa',
    group = 'Sem grupo',
    driverFaceCluster,
  } = mediaData;

  const getDriverSpan = () => {
    if (driverFaceCluster?.driver?.name) {
      return (
        <div className={styles.alignIcons}>
          <HintPopup title='Com identificação facial ' placement='top' arrow>
            <div className={styles.faceRecognitionIcon}>
              <FaceRecognitionIcon />
            </div>
          </HintPopup>
          <DescriptionTitle className={styles.spanContent}>
            {driverFaceCluster.driver.name}
          </DescriptionTitle>
        </div>
      );
    }

    return (
      <div className={styles.alignIcons}>
        <DriversCbIcon />
        <DescriptionTitle className={styles.spanContent}>
          {driverName ?? 'Sem Motorista Associado'}
        </DescriptionTitle>
      </div>
    );
  };

  return (
    <div className={styles.driverInfo}>
      {getDriverSpan()}
      <CircleDivider className={styles.spanContent} />
      <div className={styles.alignIcons}>
        <CarIcon />
        <DescriptionTitle className={styles.spanContent}>
          {licensePlate}
        </DescriptionTitle>
      </div>
      <CircleDivider className={styles.spanContent} />
      <div className={styles.alignIcons}>
        <VehicleGroupIcon />
        <DescriptionTitle className={styles.spanContent}>
          {group}
        </DescriptionTitle>
      </div>
      <Box marginLeft='auto' marginRight='20px'>
        <MediaFavoriteButton
          id='media-dialog-driver-info--media-favorite-button'
          isFavoriteCurrentState={mediaData.isFavorite}
          mediaId={mediaData.id}
          origin='media-modal'
        />
      </Box>
    </div>
  );
};

export default MediaDialogDriverInfo;
